module.exports = __webpack_public_path__ + "static/media/28a.0984637b.jpg";